import env from 'env'

export const getPaymetricAccessToken = (captcha: any, meta?: any) => ({
  type: 'api/paymetric/GET_PAYMETRIC_ACCESS_TOKEN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/payments/access-token?googleRecaptchaResponse=' + captcha,
      method: 'GET',
    },
  },
  meta,
})
getPaymetricAccessToken.toString = () => 'api/paymetric/GET_PAYMETRIC_ACCESS_TOKEN'
